import TagManager from 'react-gtm-module'
import { BrowserRouter } from 'react-router-dom'
import { CookieBanner } from './components/CookieBanner'
import { NpsSurveyModal } from './components/NpsSurveyModal'
import { PlanAccessNotice } from './components/PlanAccessNotice'
import AuthProvider from './contexts/AuthContext'
import { OnboardingProvider } from './contexts/OnboardingContext'
import { CookieConsentProvider } from './contexts/CookieConsentContext'
import SideMenuProvider from './contexts/SideMenuContext'
import { useHubSpotPageTracking } from './hooks/useHubSpotPageTracking'
import Router from './route'
import GlobalStyle from './styles'

declare global {
  interface Window {
    dataLayer: Array<Record<string, any>>
  }
}

const tagManagerArgs = {
  gtmId: String(import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID)
}

TagManager.initialize(tagManagerArgs)

function AppRoutes (): React.ReactElement {
  useHubSpotPageTracking()

  return (
    <>
      <Router />
      <NpsSurveyModal />
      <PlanAccessNotice />
      <CookieBanner />
      <GlobalStyle />
    </>
  )
}

export default function App (): React.ReactElement {
  window.dataLayer.push({
    event: 'pageview'
  })

  return <>
    <BrowserRouter future={{ v7_startTransition: true }}>
        <AuthProvider>
          <OnboardingProvider>
          <CookieConsentProvider>
            <SideMenuProvider>
              <AppRoutes />
            </SideMenuProvider>
          </CookieConsentProvider>
          </OnboardingProvider>
        </AuthProvider>
    </BrowserRouter>
  </>
}
